import styled from 'styled-components';

export const StyledContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    max-width: 100%;
    @media (max-width: 768px) {
    }
`;

export const StyledTopMargin = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
`;

export const StyledErrorText = styled.span`
    color: ${(p) => p.theme.colors.error};
    margin: 5px 0px;
    font-size: ${(p) => p.theme.fontSizes.label};
`;
export const StyledResendButton = styled.span`
    color: '#595959';
    font-size: ${(p) => p.theme.fontSizes.body};
    margin-top: 30px;
    width: 100%;
`;

export const StyledRecentText = styled.span`
    color: ${(p) => p.theme.colors.loopEmerald};
    margin: 15px 0px;
    font-size: ${(p) => p.theme.fontSizes.body};
    text-decoration: underline;
    cursor: pointer;
`;

export const StyledModalContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 500px;
`;
